import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";

type SchemaValidationTooltipProps = {
  title: string;
  onClick: () => void;
  actionText: string;
};

export const SchemaValidationTooltip: React.FC<
  SchemaValidationTooltipProps
> = ({ title, actionText, onClick }) => {
  return (
    <Tooltip
      footerAction={{
        text: actionText,
        onClick,
      }}
      placement="right"
      title={title}
      asChild
    >
      <span className="ml-2">
        <Icon icon={faCircleInfo} size="xs" />
      </span>
    </Tooltip>
  );
};
